// export interface IChartData {
//   y?: number;
//   x?: string | number | Date;
// }

interface IChartDataProps {
  chartData: object[];
  total: number;
  prefix?: string;
  suffix?: string;
  chartTitle: string;
  description: string;
}

export const fullWidthChartData = [
  { x: 0, y: 0 },
  { x: 10, y: 1 },
  { x: 15, y: 1.5 },
  { x: 20, y: 4 },
  { x: 21, y: 5 },
  { x: 23, y: 5.5 },
  { x: 24, y: 6.5 },
  { x: 25, y: 5 },
];
export const total = 9000000;
export const chartTitle = "Gross Volume";

export const smallChartsData: IChartDataProps[] = [
  {
    chartData: [
      { x: 2010, y: 2000 },
      { x: 2012, y: 3000 },
      { x: 2020, y: 4000 },
      { x: 2021, y: 5000 },
      { x: 2023, y: 5500 },
      { x: 2024, y: 6500 },
      { x: 2025, y: 5800 },
    ],
    total: 90000000,
    prefix: "₦",
    chartTitle: "Yearly Sales",
    description: "Total sales before deducting any fees, refunds or disputes",
  },
  {
    chartData: [
      { x: 2010, y: 2000 },
      { x: 2012, y: 3000 },
      { x: 2020, y: 4000 },
      { x: 2021, y: 5000 },
      { x: 2023, y: 5500 },
      { x: 2024, y: 6500 },
      { x: 2025, y: 5800 },
    ],
    total: 1056,
    chartTitle: "Total Transactions",
    description: "Overall number of transactions",
  },
  {
    chartData: [
      { x: 2010, y: 2000 },
      { x: 2012, y: 3000 },
      { x: 2020, y: 4000 },
      { x: 2021, y: 5000 },
      { x: 2023, y: 5500 },
      { x: 2024, y: 6500 },
      { x: 2025, y: 5800 },
    ],
    total: 1030,
    chartTitle: "Successful transactions",
    description: "Number of successful transfers",
  },
  {
    chartData: [
      { x: 2010, y: 2000 },
      { x: 2012, y: 3000 },
      { x: 2020, y: 4000 },
      { x: 2021, y: 5000 },
      { x: 2023, y: 5500 },
      { x: 2024, y: 6500 },
      { x: 2025, y: 5800 },
    ],
    total: 60,
    chartTitle: "New customers",
    description: "Newly signed up customers",
  },
  {
    chartData: [
      { x: 2010, y: 2000 },
      { x: 2012, y: 3000 },
      { x: 2020, y: 4000 },
      { x: 2021, y: 5000 },
      { x: 2023, y: 5500 },
      { x: 2024, y: 6500 },
      { x: 2025, y: 5800 },
    ],
    total: 10,
    chartTitle: "Unsuccessful transactions",
    description: "Number of unsuccessful transfers",
  },
  {
    chartData: [
      { x: 2010, y: 2000 },
      { x: 2012, y: 3000 },
      { x: 2020, y: 4000 },
      { x: 2021, y: 5000 },
      { x: 2023, y: 5500 },
      { x: 2024, y: 6500 },
      { x: 2025, y: 5800 },
    ],
    total: 11,
    chartTitle: "High Risk Payments",
    description: "We track risky payments for you",
  },
  {
    chartData: [
      { x: 2010, y: 2000 },
      { x: 2012, y: 3000 },
      { x: 2020, y: 4000 },
      { x: 2021, y: 5000 },
      { x: 2023, y: 5500 },
      { x: 2024, y: 6500 },
      { x: 2025, y: 5800 },
    ],
    total: 0.79,
    suffix: "%",
    chartTitle: "Dispute Activity",
    description: "---",
  },
  {
    chartData: [
      { x: 2010, y: 2000 },
      { x: 2012, y: 3000 },
      { x: 2020, y: 4000 },
      { x: 2021, y: 5000 },
      { x: 2023, y: 5500 },
      { x: 2024, y: 6500 },
      { x: 2025, y: 5800 },
    ],
    total: 3,
    chartTitle: "Disputes",
    description: "Check and resolve these as soon as you can",
  },
  {
    chartData: [
      { x: 2010, y: 2000 },
      { x: 2012, y: 3000 },
      { x: 2020, y: 4000 },
      { x: 2021, y: 5000 },
      { x: 2023, y: 7500 },
      { x: 2024, y: 8500 },
      { x: 2025, y: 9800 },
    ],
    total: 2900000,
    chartTitle: "Revenue Recognised",
    description: "",
  },
  {
    chartData: [
      { x: 2010, y: 0 },
      { x: 2012, y: 0 },
      { x: 2020, y: 0 },
      { x: 2021, y: 0 },
      { x: 2023, y: 0 },
      { x: 2024, y: 0 },
      { x: 2025, y: 0 },
    ],
    total: 0,
    chartTitle: "Deferred Revenue",
    description: "",
  },
];
